import { anomalyAdapter } from './slices';
import { selectBlockById } from '../farm/selectors';
import { selectLoadingState } from '../helpers';

const selectAnomaliesState = (state) => state.anomalyData.anomalies;

const anomalySelectors = anomalyAdapter.getSelectors(selectAnomaliesState);

const prepareAnomalyDataFormat = (anomalies) => {
  const changedAnomalyData = [];
  if (anomalies && anomalies.length) {
    anomalies.forEach((anomaly) => {
      const anomalyObj = {
        id: `${anomaly.name}/${anomaly.anomaly_type}`,
        type: 'Feature',
        geometry: anomaly.center,
        name: anomaly.name,
        properties: anomaly,
      };
      changedAnomalyData.push(anomalyObj);
    });
  }
  return changedAnomalyData;
};

const selectAnomaliesForBlock = (state, blockId) => {
  const anomalies = prepareAnomalyDataFormat(anomalySelectors.selectAll(state))
    .filter((d) => d.properties.block === Number(blockId));
  if (!anomalies) return undefined;
  const block = selectBlockById(state, blockId);
  const anomalyDataWithBlockName = anomalies.map((d) => ({ ...d, blockName: block && block.name }));
  return anomalyDataWithBlockName;
};

const selectAnomaliesForBlocks = (state, blockIds) => (
  blockIds.reduce((result, blockId) => {
    const anomalies = selectAnomaliesForBlock(state, blockId);
    if (anomalies && anomalies.length) {
      result.push(...anomalies);
    }
    return result;
  }, [])
);

const selectAnomalies = (state) => prepareAnomalyDataFormat(anomalySelectors.selectAll(state));

const selectLoadingAnomalies = (state) => (
  selectLoadingState(selectAnomaliesState(state)));

export {
  selectAnomalies,
  selectAnomaliesForBlock,
  selectAnomaliesForBlocks,
  selectLoadingAnomalies,
};
